import { projects, githubProfile } from "../data/projectsData.js";
import "../styles.css";
import AnimatedBackground from "../components/AnimatedCode.js";
import { useState, useEffect } from "react";

export function CodeTab() {
  const [githubData, setGithubData] = useState(githubProfile); // Initial data from your file

  useEffect(() => {
    fetch("https://api.github.com/users/PHILLIP8264")
      .then((res) => res.json())
      .then((data) => {
        setGithubData({
          username: data.login,
          bio: data.bio || githubProfile.bio,
          publicRepos: data.public_repos,
          followers: data.followers,
          following: data.following,
          profileUrl: data.html_url,
        });
      })
      .catch((err) => console.log("GitHub API Error:", err));
  }, []);

  console.log("Current Projects Data:", projects); // Check your browser console (F12)

  if (!projects || projects.length === 0) {
    return <div>Data is missing or empty!</div>;
  }

  return (
    <>
      <AnimatedBackground />
      <div className="page-section code-content-wrapper">
        {/* Projects Section */}
        <section>
          <h2 className="section-title">Featured Projects</h2>

          <div className="projects-grid">
            {projects.map((project) => (
              <div key={project.id} className="project-card">
                <div className="project-grid">
                  {/* Mockup Image */}
                  <div className="project-image">
                    <img src={project.mockupImage} alt={project.title} />
                    <img src={project.mockupImage2} alt={project.title} />
                  </div>

                  {/* Project Info */}
                  <div className="project-info">
                    <div>
                      <h3 className="project-title">{project.title}</h3>
                      <p className="project-description">
                        {project.description}
                      </p>

                      {/* Technologies */}
                      <div>
                        <p className="tech-label">Technologies:</p>
                        <div className="tech-tags">
                          {project.technologies.map((tech) => (
                            <span key={tech} className="tech-tag">
                              {tech}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="project-buttons">
                      <a
                        href={project.githubLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-secondary"
                      >
                        GitHub
                      </a>
                      <a
                        href={project.liveLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-primary"
                      >
                        Live Demo
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* GitHub Profile Section */}
        <section className="github-section">
          <h2 className="section-title">GitHub Profile</h2>

          <div className="github-card">
            <div className="github-header">
              {/* Changed githubProfile to githubData below */}
              <h3 className="github-username">{githubData.username}</h3>
              <p className="github-bio">{githubData.bio}</p>
            </div>

            {/* Stats Grid */}
            <div className="stats-grid">
              <div className="stat-card">
                <p className="stat-number">{githubData.publicRepos}</p>
                <p className="stat-label">Public Repos</p>
              </div>
              <div className="stat-card">
                <p className="stat-number">{githubData.followers}</p>
                <p className="stat-label">Followers</p>
              </div>
              <div className="stat-card">
                <p className="stat-number">{githubData.following}</p>
                <p className="stat-label">Following</p>
              </div>
            </div>

            {/* Profile Link */}
            <a
              href={githubData.profileUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="github-button"
            >
              View Full GitHub Profile
            </a>
          </div>
        </section>
      </div>
    </>
  );
}
